import { render, staticRenderFns } from "./AttributeMaster.vue?vue&type=template&id=0f7fdbfe&scoped=true"
import script from "./AttributeMaster.vue?vue&type=script&lang=js"
export * from "./AttributeMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7fdbfe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f7fdbfe')) {
      api.createRecord('0f7fdbfe', component.options)
    } else {
      api.reload('0f7fdbfe', component.options)
    }
    module.hot.accept("./AttributeMaster.vue?vue&type=template&id=0f7fdbfe&scoped=true", function () {
      api.rerender('0f7fdbfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/managment/AttributeMaster.vue"
export default component.exports